var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"primary"},[_c('v-row',{staticClass:"mb-0"},[_c('v-col',{staticClass:"text-center white--text"},[_vm._v(" Copyright © Fantasy Boxing designed by Right Click Media ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }